__turbopack_context__.v({
  "backgroundImage": "scheduleDemoModal-module-scss-module__XEH49q__backgroundImage",
  "contentDescription": "scheduleDemoModal-module-scss-module__XEH49q__contentDescription",
  "logoImage": "scheduleDemoModal-module-scss-module__XEH49q__logoImage",
  "modalHeader": "scheduleDemoModal-module-scss-module__XEH49q__modalHeader",
  "modalHeaderTitle": "scheduleDemoModal-module-scss-module__XEH49q__modalHeaderTitle",
  "scheduleDemoModal": "scheduleDemoModal-module-scss-module__XEH49q__scheduleDemoModal",
  "spinner": "scheduleDemoModal-module-scss-module__XEH49q__spinner",
  "submitButton": "scheduleDemoModal-module-scss-module__XEH49q__submitButton",
  "tenantName": "scheduleDemoModal-module-scss-module__XEH49q__tenantName",
});
